import { createProvider } from '@nvision/services/data-provider';
import { normalizeQuoteCargoTypesList } from '@views/screens/Quote/data-provider/quote-cargo-types-list/normalize';

import * as api from './api';

export const fetchQuoteCargoTypesList = createProvider(api.fetchQuoteCargoTypesList)
  .andThen((res) => normalizeQuoteCargoTypesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
